import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(
  () => ({
    listButtonClass: {
      '& > .hst-fab': {
        top: '5px !important',
        right: '5px',
      },
    },
    sectionButtonClass: {
      position: 'relative',
      '& > .hst-fab': {
        top: '-20px !important',
        right: '-5px',
      },
    },
  }),
  { name: 'GenGlobalFooterContainer' },
);
